import CuratenieBirouriSedii from "pages/Servicii/ServiciiSpeciale/CuratenieBirouriSedii";

export default function CuratenieBirouriSediiPage() {
    return <CuratenieBirouriSedii />;
}
